import StyledWrapper from "./style";
import { IndividualEmployeeResponseService } from "../../services/Company/Employee.type";
import { PhoneNumber } from "../../utils/phoneNumber";
const EmployeeData = (props: any) => {
  let employee: IndividualEmployeeResponseService = props.data;

  return (
    <>
      <StyledWrapper.DatosContainer>
        <StyledWrapper.InfoGrouping>
          <StyledWrapper.InfoContainer>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Apellido y Nombre</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.name || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Fecha de nacimiento</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.birthDate || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>DNI o Pasaporte</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.DNI || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>


            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>CUIL</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {(employee?.cuil === "Pendiente" || employee?.cuil === ""
                  ? "Pendiente"
                  : employee?.cuil) || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>


            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Nacionalidad</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.nationality.toLocaleLowerCase() || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Estado civil</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.maritalStatus.toLocaleLowerCase() || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Sexo</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.sex.toLocaleLowerCase() || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>E-mail</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.email.toLowerCase() || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Teléfono</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {PhoneNumber(employee?.phoneNumber) || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

          </StyledWrapper.InfoContainer>
        </StyledWrapper.InfoGrouping>




        <StyledWrapper.InfoGrouping>
          <StyledWrapper.InfoContainer>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Dirección</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.fullAddress || "Pendiente"}
                <br />
                {employee?.supplementaryReference || ""}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>


            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Ciudad</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.city || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
            
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Provincia</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {employee?.province || "Pendiente"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

          </StyledWrapper.InfoContainer>
        </StyledWrapper.InfoGrouping>


      </StyledWrapper.DatosContainer>
    </>
  );
};
export default EmployeeData;
